import { render, staticRenderFns } from "./TopContentTitle.vue?vue&type=template&id=72613118&scoped=true&"
import script from "./TopContentTitle.vue?vue&type=script&lang=ts&"
export * from "./TopContentTitle.vue?vue&type=script&lang=ts&"
import style0 from "./TopContentTitle.vue?vue&type=style&index=0&id=72613118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72613118",
  null
  
)

export default component.exports